import * as Types from '../constants/actionTypes';
const initState = {
    requestCarrierLabels: {},
    requestStatusProgress: [],
    requestQuoteDetails: {},
    requestDocsList: [],
    requestCircleDocList: [],
    requestAddtionalFields: {}
}
export default (state = initState, action) => {


    switch (action.type) {
        case Types.IS_PROCESS_LOADING:

            return {
                ...state,
                isLoading: action.isLoading
            }

        case Types.SET_PROCESS_LIST:
            return {
                ...state,
                allProcessList: action.allProcessList
            }

        case Types.PROCESS_LIST_ERROR:
            return {
                ...state,
                error: action.error
            }
        case Types.PROCESS_DETAIL_DATA:
            let finalRequestDetail = action.selectedProcessData
            if (state.selectedProcessData && Object.keys(state.selectedProcessData).length) {
                finalRequestDetail = action.selectedProcessData
                const checkExistKeys = ["requestTypeInfo", "clientInfo", "portalInfo", "carrierInfo", "recyclintPartnerInfo"]
                for (let oneKey of checkExistKeys) {
                    if (state.selectedProcessData[oneKey] && action.selectedProcessData && !action.selectedProcessData[oneKey]) {
                        finalRequestDetail[oneKey] = state.selectedProcessData[oneKey]
                    }
                }
            }
            return {
                ...state,
                selectedProcessData: finalRequestDetail
            }
        case Types.PROCESS_DETAIL_ERROR:
            return {
                ...state,
                processDetailError: action.processDetailError
            }

        case Types.REQUEST_STATUSES_LIST:
            return {
                ...state,
                requestStatuesList: action.requestStatuesList
            }
        // request status list 
        case Types.PORTAL_REQUEST_STATUS_LIST:
            return {
                ...state,
                portalRequestStatusList: action.portalRequestStatusList
            }
        case Types.REQUEST_STATUSES_ERROR:
            return {
                ...state,
                requestStatusesError: action.requestStatusesError
            }
        /*  Request status progress */
        case Types.REQUEST_STATUSES_PROGRESS: {
            return {
                ...state,
                requestStatusProgress: action.requestStatusProgress && action.requestStatusProgress.reverse()
            }
        }
        case Types.UPDATED_REQUEST_PROGRESS_DATA:
            const selectedProgressIndex = state.requestStatusProgress && state.requestStatusProgress.findIndex((oneData) => { return oneData.isStatusRejected === true })
            if (selectedProgressIndex > -1) {
                state.requestStatusProgress[selectedProgressIndex] = action.progressUpdatedData
            }
            return {
                ...state
            }
        case Types.SET_REQUEST_REJECTED: {
            return {
                ...state,
                isRequestRejected: action.isRequestRejected
            }
        }
        case Types.SELECTED_REQUEST_STATUS_SEQUENCE: {
            return {
                ...state,
                selectedStatusSequence: action.selectedStatusSequence
            }
        }
        case Types.PROCESS_ASSETS_DATA: {
            return {
                ...state,
                assetsList: action.saveAssetsList
            }
        }
        case Types.PROCESS_EXCEL_ASSETS_DATA: {
            return {
                ...state,
                assetsExcelList: action.saveExcelAssetsList//saveExcelAssetsList
            }
        }
        case Types.PROCESS_DETAIL_UPDATE:
            return {
                ...state,
                updateStatus: action.updateStatus
            }
        case Types.GET_ADDITIONAL_INFO_SUCCESS:
            return {
                ...state,
                additionalInfo: action.payload
            }
        case Types.GET_ADDITIONAL_INFO_DATA_SUCCESS:
            return {
                ...state,
                additionalInfo: action.payload
            }

        case Types.GET_REQUEST_PACKING_SUCCESS:
            return {
                ...state,
                requestPacking: action.payload
            }
        case Types.GET_REQUEST_SERVICE:
            return {
                ...state,
                addedRequestService: action.payload
            }
        case Types.GET_COLLECTION_SITE:
            return {
                ...state,
                collectionSiteInfo: action.payload
            }
        case Types.GET_DESTINATION_SITE:
            return {
                ...state,
                destinationAddress: action.payload
            }
        case Types.GET_REQUEST_SERVICE_ERROR:
            return {
                ...state,
                requestServiceError: action.error
            }
        case Types.REQUEST_QUOTE_DETAILS:
            return {
                ...state,
                requestQuoteDetails: action.requestQuoteDetails
            }
        case Types.GET_ADDRESS_LIST:
            return {
                ...state,
                addressList: action.addressList
            }

        /* Request Docs List */
        case Types.REQUEST_DOCS_LIST:
            return {
                ...state,
                requestDocsList: action.docList
            }
        case Types.REQUEST_CARRIER_LABELS:
            const keyName = `request_${action.requestId}`
            const requestCarrierLabels = state.requestCarrierLabels
            requestCarrierLabels[keyName] = action.data
            return {
                ...state,
                requestCarrierLabels
            }

        case Types.REQUEST_CIRCLE_DOCS_LIST:
            return {
                ...state,
                requestCircleDocList: action.docList
            }
        case Types.REPORT_DOCS_LIST:
            return {
                ...state,
                reportDocList: action.docList
            }
        case Types.REPORT_DOC_COUNT:
            return {
                ...state,
                portalDocsCount: action.docCount
            }
            case Types.REPORT_TAG_DETAILS:
                return {
                    ...state,
                    reportDocTags: action.tagDetails
                }
        case Types.PORTAL_DOC_DELETED:
            const deletedDocIndex = state.reportDocList && state.reportDocList.findIndex((oneDoc) => { return oneDoc.id === action.delId })
            console.log(`dlete Index is :`, deletedDocIndex)
            if (deletedDocIndex >= 0) {
                state.reportDocList.splice(deletedDocIndex, 1);
            }

            return {
                ...state
            }

        case Types.REPORT_DOCS_ERROR:
            return {
                ...state,
                reportDocError: action.error
            }
        case Types.REQUEST_DOC_DELETED:
            if (action.docEnv === 'circle') {
                const delIndex = state.requestCircleDocList && state.requestCircleDocList.findIndex(oneCircle => { return oneCircle.id === action.delId })
                if (delIndex >= 0) {
                    state.requestCircleDocList.splice(delIndex, 1)
                }
            } else {
                const delIndex = state.requestDocsList && state.requestDocsList.findIndex(nonCircle => { return nonCircle.id === action.delId })
                if (delIndex >= 0) {
                    state.requestDocsList.splice(delIndex, 1)
                }
            }
            return {
                ...state
            }
        case Types.REQUEST_DOCS_ERROR:
            return {
                ...state,
                requestDocError: action.error
            }
        case Types.ADDED_REQUEST_DOCUMNET:
            if (action.isCircleReport) {
                state.requestCircleDocList.push(action.addedDoc);
                state.bookingFeeReportInvalidRows = action.addedDoc.errorRow || 0;
            } else {
                state.requestDocsList.push(action.addedDoc)
            }

            if (action.docTypeId === -1) {
                state.reportDocList.push(action.addedDoc)
            }
            return {
                ...state
            }
        case Types.REQUEST_DOC_ITEM:
            if (action.payload) {
                const existListIndex = state.requestDocsList.findIndex((oneList) => { return oneList.docTypeId === action.payload.docTypeId })
                if (existListIndex > -1) {
                    state.requestDocsList[existListIndex] = action.payload
                }
            }
            return {
                ...state
            }
        case Types.REQUEST_TYPE_CHART_SUCCESS:
            return {
                ...state,
                requestTypesChart: action.dataList
            }
        case Types.REQUEST_STATUS_CHART_SUCCESS:
            return {
                ...state,
                requestStatusChart: action.dataList
            }
        case Types.REQUEST_CLIENT_CHART_SUCCESS:
            return {
                ...state,
                requestClientChart: action.clientdataList
            }
        case Types.REQUEST_PROCESSING_CHART_SUCCESS:
            return {
                ...state,
                requestProcessingChart: action.processingdataList
            }
        case Types.ASSIGN_PO:
            return {
                ...state,
                poAsigned: action.payload
            }
        case Types.ASSIGN_PO_ERROR:
            return {
                ...state,
                assignPOError: action.error
            }
        case Types.GET_ASSIGN_PO:
            return {
                ...state,
                poByrequest: action.payload
            }
        case Types.ASSIGN_PO_UPDATE:
            return {
                ...state,
                updatedPO: action.payload
            }
        case Types.REQUEST_ADDITIONAL_FIELD_DATA:
            return {
                ...state,
                requestAddtionalFields: action.requestAddtionalFields
            }
        case Types.PORTAL_ADDITIONAL_FIELD_ERROR:
            return {
                ...state,
                portalAddFieldsError: action.portalAddFieldsError
            }
        case Types.SAVE_FILTER:
            return {
               ...state,
                savedFilter: action.savedFilter
            }
        case Types.REQUEST_EXCEL_DOCS_ERROR:
            return {
                ...state,
                requestExcelDocError: action.requestExcelDocError
            }
        case Types.STATUS_REPORT_UPLOAD_SUCCESS:
            return {
                ...state,
                statusReportUploadSuccess: action.payload.message,
                processingResult: action.payload.data
            }
        case Types.STATUS_REPORT_UPLOAD_ERROR:
            return {
                ...state,
                statusReportUploadError: action.error
            }
        default:
            return state
    }

}